import React from 'react';
import PropTypes from 'prop-types';
import {
    Edit as EditIcon,
    Delete as DeleteIcon,
} from '@material-ui/icons';
import {isEmpty} from 'lodash/lang';
import {withThinkscapeTableWrapper, ThinkscapeTableCore, SortingManager, DeletionConfirm} from './index';


export default withThinkscapeTableWrapper(
    class __ThinkscapeTable extends React.Component {
        static propTypes = {
            recordPages: PropTypes.object.isRequired,
            onSortableFieldClick: PropTypes.func.isRequired,
            hiddenFields: PropTypes.array,
            itemName: PropTypes.string.isRequired,
            getFieldsMapping: PropTypes.func.isRequired,
            fieldsSettings: PropTypes.object.isRequired,
        };

        constructor(props) {
            super(props);
            this.showDeletionConfirm = this.showDeletionConfirm.bind(this);
            this.buildRecords = this.buildRecords.bind(this);
            this.buildSettings = this.buildSettings.bind(this);
            this.sortingManager = new SortingManager();
            this.deletionConfirmBoxRef = React.createRef();
        }

        showDeletionConfirm(record) {
            this.setState({
                recordToRemove: record,
            }, this.deletionConfirmBoxRef.current.openModal);
        }

        buildRecords(records) {
            const {getFieldsMapping} = this.props;
            const sortedIds = records.sortedIds || [];
            return isEmpty(sortedIds) ? [] : sortedIds.map(recordId => {
                const record = records[recordId];
                return {
                    record,
                    id: record._id.$oid,
                    ...getFieldsMapping(record),
                    actions: '',
                };
            });
        }

        buildSettings() {
            let {fieldsSettings, canDelete = true} = this.props;
            return {
                ...fieldsSettings,
                actions: !isEmpty(fieldsSettings.actions) ? fieldsSettings.actions : {
                    fieldText: 'Actions',
                    formatData: (cell, row, restProps) => (
                        <span className="table-actions">
                            {
                                restProps.showUpdateModal &&
                                <EditIcon className="cursor-pointer" onClick={() => restProps.showUpdateModal(row.record)}/>
                            }
                            {
                                canDelete && (
                                    (restProps.onDeleteActionClick || restProps.showDeletionConfirm) &&
                                    <DeleteIcon className="cursor-pointer" onClick={() => restProps.showDeletionConfirm(row)}/>
                                )
                            }
                        </span>
                    ),
                },
            };
        }

        render() {
            const {
                recordPages,
                onSortableFieldClick,
                hiddenFields,
                onDeleteActionClick,
                showUpdateModal,
                itemName,
                ...restProps
            } = this.props;
            const records = this.buildRecords(recordPages[recordPages.currentPage] || {});
            const settings = this.buildSettings();
            return (
                <>
                    {
                        onDeleteActionClick && (
                            <DeletionConfirm
                                ref={this.deletionConfirmBoxRef}
                                itemName={itemName}
                                deleteAction={() => onDeleteActionClick(this.state.recordToRemove)}
                                DeleteButton="span"
                            />
                        )
                    }
                    <ThinkscapeTableCore {...{
                        records,
                        settings,
                        sortingManager: this.sortingManager,
                        onSortableFieldClick,
                        hiddenFields,
                        showDeletionConfirm: this.showDeletionConfirm,
                        showUpdateModal,
                        ...restProps,
                    }} />
                </>
            );
        }
    }
);
